"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StartStreamButton = StartStreamButton;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StartStreamButton = require("./StartStreamButton.styled");
var toolTipStyle = {
  backgroundColor: '#fff',
  color: '#000'
};
function StartStreamButton(_ref) {
  var id = _ref.id,
    tooltipText = _ref.tooltipText,
    disabled = _ref.disabled,
    dataTestId = _ref.dataTestId,
    tooltipPlacement = _ref.tooltipPlacement,
    toolTipWidth = _ref.toolTipWidth,
    onClick = _ref.onClick,
    isLive = _ref.isLive;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_StartStreamButton.ButtonWrapper, {
    id: id
  }, _react["default"].createElement(_StartStreamButton.StyledButton, {
    "data-testid": dataTestId,
    disabled: disabled,
    onClick: onClick,
    isLive: isLive
  }, _react["default"].createElement(_StartStreamButton.ButtonText, null, isLive ? 'End the stream' : 'Start the stream'))), _react["default"].createElement(_StartStreamButton.StyledToolTip, {
    id: "tooltip_".concat(id),
    placement: tooltipPlacement,
    style: toolTipStyle,
    target: id,
    toolTipWidth: toolTipWidth
  }, tooltipText));
}
StartStreamButton.defaultProps = {
  id: 'start-stream-button',
  tooltipPlacement: 'top',
  toolTipWidth: 200
};
StartStreamButton.propTypes = {
  tooltipText: _propTypes["default"].string,
  id: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  tooltipPlacement: _propTypes["default"].string,
  toolTipWidth: _propTypes["default"].number,
  onClick: _propTypes["default"].func.isRequired,
  isLive: _propTypes["default"].bool.isRequired
};